// The active data Space (Hive Phase C). Apps scope their data to this id
// instead of hardcoding `userInfo.company`. Default = the user's home space
// (their companyId), so behavior is unchanged until they switch spaces.
//
// Stored in localStorage (cleared on logout by AuthUtil.handleLogout →
// localStorage.clear()). Switching spaces reloads the app so every screen
// picks up the new active space.

const KEY = 'hive.activeSpaceId';

export function homeSpaceId(userInfo) {
  return userInfo?.company || userInfo?.companyId || null;
}

export function activeSpaceId() {
  try {
    return localStorage.getItem(KEY);
  } catch (e) {
    return null;
  }
}

export function getSpaceId(userInfo) {
  return activeSpaceId() || homeSpaceId(userInfo);
}

export function setActiveSpace(spaceId) {
  try {
    if (spaceId) localStorage.setItem(KEY, spaceId);
    else localStorage.removeItem(KEY);
  } catch (e) {
    /* no-op */
  }
}

export function clearActiveSpace() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    /* no-op */
  }
}
